import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab, Paper } from '@material-ui/core'

import { getShopList } from '../../../actions/shop'

import {
  getACHAccountList,
  setACHAccounts,
  createACHAccount,
  updateACHAccount,
  deleteACHAccount,
} from '../../../actions/integration'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import StrongholdShopInfo from '../../../components/Stronghold/StrongholdShopInfo'
import { Appcues } from '../../../utils/constants'

const achTabs = ['Shop']

class Stronghold extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Shop',
      editMode: false,
      channelOptions: [],
    }
  }

  componentDidMount() {
    this.props.dispatch(getShopList()).then((res) => {
      this.getACHList(res)
    })
  }

  enableEdit = () => {
    this.setState({
      editMode: true,
    })
  }

  disableEdit = () => {
    this.setState({
      editMode: false,
    })
  }

  onChannelCancel = () => {
    const { channelOptions } = this.props.shopReducer
    this.setState({
      channelOptions: channelOptions,
      editMode: false,
    })
  }

  getACHList = (shops) => {
    let data = {}
    const { session = {} } = this.props.authReducer
    const { company = {} } = session
    this.props.dispatch(getACHAccountList(company.id)).then((achAcounts) => {
      const achAcountsValues = (achAcounts && achAcounts.values) || []
      shops &&
        shops.values &&
        shops.values.length &&
        shops.values.forEach((item) => {
          const achAccount =
            achAcountsValues.find(
              (acc) => acc.shopId === item.id && acc.paymentOption === 'Stronghold',
            ) || {}
          data[item.id] = { ...(data[item.id] || {}), ...achAccount, shopId: item.id }
        })

      this.props.dispatch(setACHAccounts(data))
    })
  }

  achTabs = achTabs.map((tab) => <Tab label={tab} value={tab} />)

  onShopSave = (data, afterOnSave) => {
    const { shopsList = {} } = this.props.shopReducer
    const { session = {} } = this.props.authReducer
    const { company = {} } = session

    if (company !== null) {
      data = {
        ...data,
        companyId: company.id,
      }
    }

    if (data.id) {
      this.props.dispatch(updateACHAccount(data)).then((response) => {
        Appcues.track('Stronghold Account Updated')
        this.getACHList(shopsList)
        afterOnSave(response)
      })
    } else {
      this.props.dispatch(createACHAccount(data)).then((response) => {
        Appcues.track('Stronghold Account Created')
        this.getACHList(shopsList)
        afterOnSave(response)
      })
    }
  }
  onChannelChange = (index) => (key, value) => {
    const { channelOptions } = this.state

    let updatedChannelOptions = [...channelOptions]

    updatedChannelOptions[index] = { ...updatedChannelOptions[index], [key]: value }

    this.setState({
      channelOptions: updatedChannelOptions,
    })
  }

  renderTab = (activeTab) => {
    const { editMode, channelOptions } = this.state

    const { shopsList = {} } = this.props.shopReducer

    const { achList = {} } = this.props.integrationReducer

    const integrationLastModified = this.props.integrationReducer.lastModified

    switch (activeTab) {
      case 'Shop':
        return (
          <StrongholdShopInfo
            achList={achList}
            onSave={this.onShopSave}
            lastModified={integrationLastModified}
            shopsList={shopsList}
            onDelete={this.onShopDelete}
          />
        )
      default:
        return null
    }
  }

  onShopDelete = (accountId) => {
    const { shopsList = {} } = this.props.shopReducer

    this.props.dispatch(deleteACHAccount(accountId)).then((res) => {
      Appcues.track('Stronghold Account Deleted')
      this.getACHList(shopsList)
    })
  }

  handleChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  render() {
    const { activeTab } = this.state

    return (
      <div>
        <Paper>
          <Tabs
            value={activeTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {this.achTabs}
          </Tabs>
        </Paper>
        {this.renderTab(activeTab)}
        {/* <ModalDialog 
                    title={'Warning'}
                    ref={(c) => this.confirmModal = c}
                    onConfirm={this.createNewWorker}
                    confirmText={'Yes'}
                >
                    <p>This employee doesn't exist, Do you want to create new agent at tookan?</p>
                </ModalDialog> */}
      </div>
    )
  }
}

const StrongholdWithTitle = ContainerWithTitleWrapper(Stronghold, 'Stronghold Management')
const StrongholdConnected = connect(
  ({ shopReducer, integrationReducer, dispatch, authReducer }) => ({
    shopReducer,
    integrationReducer,
    dispatch,
    authReducer,
  }),
)(StrongholdWithTitle)

export default StrongholdConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/Stronghold.js